import {AbstractService} from "@/services/AbstractService";
import {app} from "@/app";

export class AttributionsUpdate extends AbstractService {
    async handle() {
        if(!app.configOption('shopify.attributionsUpdate.enabled')) return;

        app.debug('Pixel: Shopify Event AttributionsUpdate: started');

        await app.storage.pixel.context.collect();

        const key = app.configOption('shopify.attributionsUpdate.cartAttributeKey');

        const payload = {
            attributes: {
                [key]: btoa(JSON.stringify(app.storage.pixel.context.record)),
            }
        };

        const url = `${app.storage.shopify.shop.routesRoot}cart/update.js`
        fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
        }).then(response => {
            if (response.ok) {
                app.debug('Pixel: Shopify Event AttributionsUpdate: SENT');
                return;
            }

            app.debug('Pixel: Shopify Event AttributionsUpdate: ERROR', {
                status: response.statusText,
            }, 'error');
        }).catch(error => {
            app.debug('Pixel: Shopify Event AttributionsUpdate: EXCEPTION', {
                error: error,
            }, 'error');
        });
    }
}
